export default __webpack_public_path__ + "static/media/03.d29b4e2a.jpg";